var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44444 39.5556H11.6111L33.3333 17.8333L30.1667 14.6667L8.44444 36.3889V39.5556ZM6.22222 44C5.59259 44 5.06481 43.787 4.63889 43.3611C4.21296 42.9352 4 42.4074 4 41.7778L4 36.3889C4 35.7963 4.11111 35.2315 4.33333 34.6944C4.55556 34.1574 4.87037 33.6852 5.27778 33.2778L33.3333 5.27778C33.7778 4.87037 34.2685 4.55556 34.8056 4.33333C35.3426 4.11111 35.9074 4 36.5 4C37.0926 4 37.6667 4.11111 38.2222 4.33333C38.7778 4.55556 39.2593 4.88889 39.6667 5.33333L42.7222 8.44444C43.1667 8.85185 43.4907 9.33333 43.6944 9.88889C43.8982 10.4444 44 11 44 11.5556C44 12.1481 43.8982 12.713 43.6944 13.25C43.4907 13.787 43.1667 14.2778 42.7222 14.7222L14.7222 42.7222C14.3148 43.1296 13.8426 43.4444 13.3056 43.6667C12.7685 43.8889 12.2037 44 11.6111 44H6.22222ZM31.7222 16.2778L30.1667 14.6667L33.3333 17.8333L31.7222 16.2778Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.181dfe86.svg";
export { ForwardRef as ReactComponent };